import { Signal } from '@crown/signal';
import { startChrome } from '@crown/ui/chrome';


function normalizeRoutePath(routePath?: string | null) {
  return (routePath || '').replace(/^\/+/, '').replace(/\/+$/, '');
}

export function initChrome(): void {
  startChrome();
}

export function setBranding(title: string, subtitle?: string) {
  const brand = document.querySelector('.navbar-brand');
  if (brand) {
    (brand as HTMLElement).textContent = title;
  }

  const copy = document.querySelector('.docs-branding-copy');
  if (copy) {
    (copy as HTMLElement).textContent =
      subtitle || 'Source-driven architecture and deployment references';
  }

  document.title =
    title === 'Crown Docs' ? 'Crown Docs' : `${title} | Crown Docs`;
}

export function setActiveNav(routePath: string) {
  const current = normalizeRoutePath(routePath);
  const items = document.querySelectorAll<HTMLElement>('[data-nav-route]');

  for (const item of items) {
    const route = normalizeRoutePath(item.dataset.navRoute);
    const matchMode = item.dataset.navMatch || 'exact';
    const isActive =
      matchMode === 'prefix'
        ? route
          ? current === route || current.startsWith(`${route}/`)
          : current === ''
        : current === route;

    item.classList.toggle('is-active', isActive);

    if (isActive) {
      item.setAttribute('aria-current', 'page');
    } else {
      item.removeAttribute('aria-current');
    }
  }
}
